import React from 'react';
import { Star, QuoteIcon } from 'lucide-react';
const TESTIMONIALS = [{
  name: 'Martín López',
  age: '32 años',
  city: 'Buenos Aires',
  text: 'Siempre quise aprender un oficio que me diera salida laboral rápida. Vi muchos videos en YouTube pero me mareaba con tanta información suelta. Este sistema me ordenó todo. En menos de un mes ya hice mi primera instalación en la casa de un familiar y quedó perfecta. ¡Súper recomendado!'
}, {
  name: 'Carlos Ramírez',
  age: '28 años',
  city: 'Córdoba',
  text: 'No sabía absolutamente nada de cables ni de cámaras. El Tomo 2 de instalación física es oro puro. Te explica paso a paso cómo hacer el cableado sin volverte loco. Ya estoy armando presupuestos para un par de comercios en mi barrio usando lo que aprendí en el bono de clientes.'
}, {
  name: 'Diego Fernández',
  age: '41 años',
  city: 'Rosario',
  text: 'Compré el curso con un poco de desconfianza porque ya había gastado plata en otros que eran pura teoría. La diferencia acá es que es 100% práctico. La parte de configuración y acceso remoto desde el celular está explicada tan fácil que cualquiera lo puede hacer. Excelente inversión.'
}, {
  name: 'Facundo Morales',
  age: '35 años',
  city: 'Mendoza',
  text: 'Lo que más me sirvió fue el bono del Kit Profesional. Antes de arrancar casi compro un montón de herramientas caras que no necesitaba. Con esa guía compré justo lo necesario y arranqué. Ya recuperé la inversión del curso con mi primer trabajo.'
}, {
  name: 'Nicolás Pereyra',
  age: '26 años',
  city: 'Tucumán',
  text: 'Estaba buscando una forma de generar ingresos extra los fines de semana. La instalación de cámaras resultó ser ideal. El módulo de cómo cobrar y presupuestar me dio la confianza que me faltaba para empezar a ofrecer el servicio. Muy claro todo.'
}];
export function Testimonials() {
  return <section className="bg-[#0d1b2a] py-16 md:py-24 px-4 relative overflow-hidden" data-id="element-210">
      {/* Decorative background lines */}
      <div className="absolute inset-0 opacity-10 pointer-events-none" style={{
      backgroundImage: 'radial-gradient(#4a9eff 1px, transparent 1px)',
      backgroundSize: '30px 30px'
    }} data-id="element-211"></div>

      <div className="max-w-5xl mx-auto relative z-10" data-id="element-212">
        <h2 className="text-3xl md:text-5xl font-black text-center text-white mb-16 uppercase drop-shadow-sm" data-id="element-213">
          LO QUE DICEN QUIENES YA ESTÁN{' '}
          <span className="text-blue-400" data-id="element-214">APRENDIENDO</span>
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-215">
          {TESTIMONIALS.map((testimonial, index) => <div key={index} className="bg-[#0f1d32] p-8 rounded-2xl shadow-lg border border-blue-900/30 flex flex-col h-full relative group hover:-translate-y-1 hover:border-blue-500/30 transition-all duration-300" data-id="element-216">
              <QuoteIcon className="absolute top-6 right-6 w-10 h-10 text-blue-900/40 group-hover:text-blue-500/20 transition-colors" data-id="element-217" />

              <div className="flex text-yellow-400 mb-6 relative z-10" data-id="element-218">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-current drop-shadow-sm" data-id="element-219" />)}
              </div>

              <p className="text-gray-300 italic mb-8 flex-grow relative z-10 leading-relaxed" data-id="element-220">
                "{testimonial.text}"
              </p>

              <div className="border-t border-blue-900/40 pt-5 mt-auto relative z-10 flex items-center gap-3" data-id="element-221">
                <div className="w-10 h-10 rounded-full bg-blue-900/50 flex items-center justify-center border border-blue-500/20" data-id="element-222">
                  <span className="font-bold text-blue-300" data-id="element-223">
                    {testimonial.name.charAt(0)}
                  </span>
                </div>
                <div data-id="element-224">
                  <p className="font-bold text-white text-sm" data-id="element-225">
                    {testimonial.name}
                  </p>
                  <p className="text-xs text-gray-400" data-id="element-226">
                    {testimonial.age} - {testimonial.city}
                  </p>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}